import { AnyAction } from 'redux';
import { SearchResultsInitialState } from './types';
import * as constants from './constants';
const searchResultsInitialState: SearchResultsInitialState = {
  clients: [],
  services: [],
  searchResults: [],
  searchSuccess: false,
  currentClaimId: '',
  isClaimsGridLoading: false,
  isClaimsClientsLoading: false,
  isClaimsServicesLoading: false,
  isCreateClaimLoading: false,
  isExportClaimsAdvancedSearchLoading: false,
  createClaimClaimTypes: [],
  createClaimClients: [],
  createClaimRelationships: [],
  createClaimStates: [],
  createClaimClientPartnerAccounts: [],
  createClaimServices: [],
  createClaimAdjustmentReasons: [],
  createClaimClientNetworks: [],
  createClaimClientServices: [],
  claimsGridColumnConfig: ['manuallyEnteredCheck'],
};
const searchSectionReducer = (state = searchResultsInitialState, action: AnyAction) => {
  switch (action.type) {
    case constants.SET_CLAIMS_ADVANCED_SEARCH_LOOPKUP_CLIENTS:
      return {
        ...state,
        clients: action.clients,
      };
    case constants.SET_CLAIMS_ADVANCED_SEARCH_LOOPKUP_SERVICES:
      return {
        ...state,
        services: action.services,
      };
    case constants.SET_CREATE_CLAIM_LOOKUP:
      return {
        ...state,
        createClaimClaimTypes: action.createClaimClaimTypes,
        createClaimClients: action.createClaimClients,
        createClaimRelationships: action.createClaimRelationships,
        createClaimStates: action.createClaimStates,
        createClaimClientPartnerAccounts: action.createClaimClientPartnerAccounts,
        createClaimServices: action.createClaimServices,
        createClaimAdjustmentReasons: action.createClaimAdjustmentReasons,
      };
    case constants.SET_CREATE_CLAIM_CLIENT_NETWORKS:
      return {
        ...state,
        createClaimClientNetworks: action.createClaimClientNetworks,
      };
    case constants.SET_CREATE_CLAIM_CLIENT_SERVICES:
      return {
        ...state,
        createClaimClientServices: action.createClaimClientServices,
      };
    case constants.GET_SEARCH_RESULTS_SUCCESS:
      return {
        ...state,
        searchResults: action.response,
        searchSuccess: true,
      };
    case constants.RESET_SEARCH_RESULTS:
      return {
        ...state,
        searchResults: [],
        searchSuccess: false,
        currentClaimId: '',
      };
    case constants.SET_PREPAY_SEARCH_CLAIMID:
      return {
        ...state,
        currentClaimId: action.searchInput,
      };
    case constants.TOGGLE_CLAIMS_ADVANCED_SEARCH_LOOPKUP_LOADING:
      return {
        ...state,
        isClaimsClientsLoading: action.isLoading,
      };
    case constants.TOGGLE_CLAIMS_ADVANCED_SEARCH_LOOPKUP_SERVICES_LOADING:
      return {
        ...state,
        isClaimsServicesLoading: action.isLoading,
      };
    case constants.TOGGLE_CREATE_CLAIM_LOOPKUP_LOADING:
      return {
        ...state,
        isCreateClaimLoading: action.isLoading,
      };
    case constants.TOGGLE_EXPORT_CLAIMS_ADVANCED_SEARCH_LOADING: {
      return {
        ...state,
        isExportClaimsAdvancedSearchLoading: action.isLoading,
      };
    }
    case constants.SET_LOADING_INDICATOR:
      return {
        ...state,
        isClaimsGridLoading: action.isClaimsGridLoading,
        searchSuccess: action.searchSuccess,
      };
    case constants.SET_CLAIMS_GRID_COLUMN_CONFIG:
      return {
        ...state,
        claimsGridColumnConfig: action.payload,
      };
    default:
      return state;
  }
};

export default searchSectionReducer;
